import { TASK_ANSWERS_ERRORS } from './TaskAnswersFields';
export const updateTaskAnswer = ({ formState, field, id, value, }) => {
    const newTaskAnswers = formState.taskAnswers.map((answer) => answer.clientId === id ? { ...answer, [field]: value } : answer);
    formState.setTaskAnswers(newTaskAnswers);
    return newTaskAnswers;
};
export const updateTaskAnswerTranslation = ({ formState, id, lang, value, }) => {
    formState.setTaskAnswers((prev) => prev.map((answer) => answer.clientId === id
        ? {
            ...answer,
            translations: {
                ...answer.translations,
                [lang]: value,
            },
        }
        : answer));
};
export const validateAnswers = ({ taskType, taskAnswers, setTaskAnswersError, }) => {
    const correctAnswersAmount = taskAnswers.reduce((acc, current) => acc + (current.isCorrect ? 1 : 0), 0);
    switch (taskType) {
        case 'single-selection':
            if (correctAnswersAmount < 1) {
                setTaskAnswersError(TASK_ANSWERS_ERRORS.minOneCorrectAnswerRequired);
            }
            else if (correctAnswersAmount > 1) {
                setTaskAnswersError(TASK_ANSWERS_ERRORS.onlyOneCorrectAnswerAllowed);
            }
            else {
                setTaskAnswersError(null);
            }
            break;
        case 'multiple-selection':
            if (correctAnswersAmount < 1) {
                setTaskAnswersError(TASK_ANSWERS_ERRORS.minTwoCorrectAnswerRequired);
            }
            else if (correctAnswersAmount === 1) {
                setTaskAnswersError(TASK_ANSWERS_ERRORS.minTwoCorrectAnswerRequiredOrTaskTypeChange);
            }
            else {
                setTaskAnswersError(null);
            }
            break;
        default:
            setTaskAnswersError(null);
    }
};
